import { useLayoutEffect, useRef } from "react";
import "./ProjectsHeader.css";
import gsap from "gsap";

export default function ProjectsHeader() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });
      tl.from(".ph-eyebrow", { y: 16, opacity: 0, duration: 0.6 }, 0.1)
        .from(".ph-title .line", { yPercent: 110, duration: 0.9, stagger: 0.1, ease: "expo.out" }, 0.2)
        .from(".ph-sub", { y: 16, opacity: 0, duration: 0.6 }, 0.65)
        .from(".ph-stats .ph-stat", { y: 20, opacity: 0, duration: 0.6, stagger: 0.08 }, 0.75);
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <div ref={rootRef} className="projects-header">
      <div className="ph-bg" aria-hidden>
        <div className="ph-orb ph-orb--1" />
        <div className="ph-orb ph-orb--2" />
        <div className="ph-grid" />
      </div>
      <div className="ph-inner">
        <span className="ph-eyebrow eyebrow">Portfolio · 2023 — 2026</span>
        <h1 className="ph-title">
          <span className="line-wrap"><span className="line">Projects</span></span>
        </h1>
        <p className="ph-sub">A selection of production work — real clients, real users, deployed and maintained.</p>
        <div className="ph-stats">
          <div className="ph-stat"><strong>7</strong><span>Projects</span></div>
          <div className="ph-stat"><strong>5</strong><span>Clients</span></div>
          <div className="ph-stat"><strong>3</strong><span>Years</span></div>
        </div>
      </div>
    </div>
  );
}
